import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  purchaseSettings: Yup.object().shape({
    payment: Yup.object().shape({
      paymentThreshold: Yup.object().shape({
        hasThreshold: Yup.boolean(),
        ticketValueThreshold: Yup.string().when(['hasThreshold'], {
          is: true,
          then: Yup.string().required('A value is required.'),
        }),
        allowedPaymentTypes: Yup.array().when(['hasThreshold'], {
          is: true,
          then: Yup.array().min(1, 'At least one payment type is required.'),
        }),
      }),
    }),
  }),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
